import { Alert, Box, Paper, Typography } from "@mui/material";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { reportsApiV2, type ConsolidatedStockRow } from "@/api/endpoints";
import { errorMessage } from "@/api/client";

/**
 * UC-M2-WH-01 — total on-hand per item across every branch's warehouse.
 * Reads off the immutable ledger; the spec NFR-P05 threshold is &lt; 5s P95 for 100 branches.
 */
export function ConsolidatedStockPage() {
  const query = useQuery({
    queryKey: ["consolidated-stock"],
    queryFn: () => reportsApiV2.consolidatedStock(),
  });

  const columns: GridColDef<ConsolidatedStockRow>[] = [
    { field: "itemName", headerName: "Item", flex: 1.5, minWidth: 240,
      renderCell: (p) => <span><b>{p.row.itemName}</b> <span style={{ color: "#888" }}>{p.row.sku}</span></span> },
    { field: "totalOnHand", headerName: "On hand (all WH)", width: 160, type: "number" },
    { field: "totalReserved", headerName: "Reserved", width: 120, type: "number" },
    { field: "totalAvailable", headerName: "Available", width: 120, type: "number" },
    { field: "warehouseCount", headerName: "Warehouses", width: 130, type: "number" },
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>Consolidated stock</Typography>
      <Paper sx={{ p: 2 }}>
        {query.isError && <Alert severity="error" sx={{ mb: 2 }}>{errorMessage(query.error)}</Alert>}
        <Box sx={{ height: 600 }}>
          <DataGrid
            rows={query.data ?? []} columns={columns} loading={query.isLoading}
            getRowId={(row) => row.itemId}
            disableRowSelectionOnClick
            initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Box>
      </Paper>
    </Box>
  );
}
